import { useEffect } from 'react';
import useHandleTrackEvent from 'hooks/useHandleTrackEvent';
import { useLocation } from 'react-router-dom';
import { updateUiState } from '@/redux/slices/uiSlice';
import { useDispatch } from 'react-redux';
import { emailColors as defaultEmailColors } from '@/utils/constants';

/**
 * Hook to track page views and send analytics events.
 * Listens for location changes and dispatches a 'page_view' event.
 */
const usePageTracking = () => {
  const location = useLocation();
  const { pathname, search } = location;
  const handleTrackEvent = useHandleTrackEvent();
  const dispatch = useDispatch();

  useEffect(() => {
    const forceReload = localStorage.getItem('FORCE_RELOAD');
    if (forceReload) {
      dispatch(
        updateUiState({
          key: 'emailColors',
          value: defaultEmailColors,
        }),
      );
      localStorage.removeItem('FORCE_RELOAD');
      setTimeout(() => {
        window.location.reload(true);
      }, 0);
    }
    handleTrackEvent('page_view', {
      context: `${pathname}${search}`,
    });
  }, [pathname]);
};

export default usePageTracking;
